"use client";
import React, { createContext, ReactNode, useEffect, useState } from "react";

export type SectionColor = {
    id: string;
    sectionKey: string;
    colorCode: string;
    defaultColorCode: string;
};

interface ColorStyleContextData {
    headerBg: string | null;
    contentBg: string | null;
    menuTextNormal: string | null;
    menuTextHover: string | null;
    menuBgNormal: string | null;
    menuBgHover: string | null;
    sideMenuTextNormal: string | null;
    sideMenuBgNormal: string | null;
    headingMain: string | null;
    headingSub: string | null;
    text: string | null;
    buttonTextNormal: string | null;
    buttonTextHover: string | null;
    buttonBgNormal: string | null;
    buttonBgHover: string | null;
    link: string | null;
    linkHover: string | null;
    tableText: string | null;
    footerText: string | null;
    footerBg: string | null;
}

const ColorStyleContext = createContext<ColorStyleContextData>({} as ColorStyleContextData);

export const ColorStyleProvider = ({
    children,
    sectionColor,
}: {
    children: ReactNode;
    sectionColor: SectionColor[];
}) => {
    const [colorStyleData, setColorStyleData] = useState<ColorStyleContextData>({
        headerBg: "#ffffff",
        contentBg: "#ffffff",
        menuTextNormal: "#1d1d1f",
        menuTextHover: "#0050AF",
        menuBgNormal: "#F8F8F8",
        menuBgHover: "#F8F8F8",
        sideMenuTextNormal: "#1d1d1f",
        sideMenuBgNormal: "#ffffff",
        headingMain: "#006ef2",
        headingSub: "#1d1d1f",
        text: "#1d1d1f",
        buttonTextNormal: "#ffffff",
        buttonTextHover: "#ffffff",
        buttonBgNormal: "#3b82f6",
        buttonBgHover: "#155dfc",
        link: "#006ef2",
        linkHover: "#006ef2",
        tableText: "#747474",
        footerText: "#ffffff",
        footerBg: "#006ef2",
    });

    useEffect(() => {
        const colorStyle = sectionColor.reduce(
            (acc, cur) => {
                acc[cur.sectionKey] = cur.colorCode;
                return acc;
            },
            {} as Record<string, string>,
        );

        setColorStyleData((prev) => {
            return {
                ...prev,
                ...colorStyle,
            };
        });
    }, [sectionColor]);

    return <ColorStyleContext.Provider value={colorStyleData}>{children}</ColorStyleContext.Provider>;
};

export default ColorStyleContext;
